import React from "react";
import { Box } from "rebass/styled-components";
import theme from "../../../../../theme/themeThree";
import { Body, Title3 } from "../../../../Components/Text";

type TProps = {
  title: string;
  subtitle: string;
  children?: React.ReactNode;
  warning?: string;
  variant?: string;
};

export function Subscription({
  title,
  subtitle,
  children,
  warning,
  variant,
}: TProps) {
  return (
    <Box
      variant={variant ? variant : "subscriptionsContainer"}
      textAlign="center"
      color="envy"
    >
      {title ? <Title3 mb={subtitle ? 3 : 6}>{title}</Title3> : null}
      {warning ? (
        <Body mb={subtitle ? 3 : 6} color={"error"}>
          {warning}
        </Body>
      ) : null}
      {subtitle ? (
        <Body color={"chalk"} mb={theme.margins.body}>
          {subtitle}
        </Body>
      ) : null}
      {children}
    </Box>
  );
}
